export default () => (
  <svg className="spinner" width="50" height="50" viewBox="0 0 66 66">
    <circle className="path" fill="none" strokeWidth="6" strokeLinecap="round" cx="33" cy="33" r="30" />
  </svg>
)
